'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import { connect } from 'react-redux';
import partial from 'transmute/partial';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import { withRouter } from 'react-router-dom';
import { isHSFXEligibleSelector } from 'pricing-pages-unified-ui/selectors/PromotionSelectors';
import StickyContainer from '../common/StickyContainer';
import { TabConfig, TabEnum } from '../../constants/TabConfig';
import MobileTabs from './MobileTabs';
import { tabsNavigateTo } from 'pricing-pages-lib/utils/urls';
import styled from 'styled-components';
import breakpoint from '../../utils/responsiveBreakpoints';
const PrimaryTabContainer = styled(UITabs).withConfig({
  displayName: "Tabs__PrimaryTabContainer",
  componentId: "sc-1h3nqnq-0"
})(["text-align:center;margin-bottom:1px;display:block;.pricing-page-tab{height:68px;width:280px;text-align:center;padding-top:24px;padding-bottom:24px;font-size:16px;&:hover{font-size:16px;}}", ";"], breakpoint.tablet(_t || (_t = _`
    display:none;
`)));
const SecondaryTabContainer = styled(UITabs).withConfig({
  displayName: "Tabs__SecondaryTabContainer",
  componentId: "sc-1h3nqnq-1"
})(["display:block;.products-page-tab{height:68px;width:", ";text-align:center;padding-top:28px;font-size:16px;&:hover{font-size:16px;}}", ";"], props => props.selectedPrimaryTab === TabEnum.BUNDLE ? '280px' : '200px', breakpoint.tablet(_t2 || (_t2 = _`
    display:none;
    `)));

const getSecondaryTabStyle = ({
  id,
  selected
}) => id === selected ? {
  backgroundColor: CALYPSO_LIGHT
} : {};

function Tabs({
  selectedPrimaryTab,
  selectedSecondaryTab,
  history,
  defaultHubRoute,
  isHSFXEligible
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MobileTabs, {
      selectedPrimaryTab: selectedPrimaryTab,
      selectedSecondaryTab: selectedSecondaryTab,
      isHSFXEligible: isHSFXEligible,
      tabConfig: TabConfig,
      history: history
    }), /*#__PURE__*/_jsx(PrimaryTabContainer, {
      selected: selectedPrimaryTab,
      use: "enclosed",
      children: Object.keys(TabConfig).map(tabKey => {
        const {
          getTitle,
          slug
        } = TabConfig[tabKey];
        return /*#__PURE__*/_jsx(UITab, {
          tabId: tabKey,
          className: "pricing-page-tab",
          onClick: () => {
            tabsNavigateTo({
              path: slug(selectedSecondaryTab) || defaultHubRoute,
              history
            });
          },
          title: getTitle()
        }, tabKey);
      })
    }), /*#__PURE__*/_jsx(StickyContainer, {
      children: /*#__PURE__*/_jsx(SecondaryTabContainer, {
        selected: selectedSecondaryTab,
        bordered: true,
        selectedPrimaryTab: selectedPrimaryTab,
        children: TabConfig[selectedPrimaryTab].children.map(tab => /*#__PURE__*/_jsx(UITab, {
          tabId: tab.id,
          className: "products-page-tab",
          onClick: partial(tabsNavigateTo, {
            path: `/${tab.slug || tab.id}`,
            history
          }),
          title: tab.getTitle({
            isHSFXEligible
          }),
          style: getSecondaryTabStyle({
            id: tab.id,
            selected: selectedSecondaryTab
          })
        }, tab.id))
      })
    })]
  });
}

function mapStateToProps(state) {
  return {
    defaultHubRoute: state.config.defaultHubRoute,
    isHSFXEligible: isHSFXEligibleSelector(state)
  };
}

export default withRouter(connect(mapStateToProps)(Tabs));